import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-148" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-149" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-150" data-mp="3fy2z7vpm7s3i">
          What neurology students are saying
        </h2>
        <div className="mt-2 space-y-2" data-id="element-151" data-mp="36ziophu7koqd">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 bg-mist px-2.5 py-2" data-id="element-152" data-mp="31zwc9am7fcim">
              <div className="flex gap-0.5 text-gold" role="img" aria-label="5 out of 5 stars" data-id="element-153" data-mp="2x0tbi2d9bsgg">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-154" data-mp="2s39skp5m6ri6" data-mpi={i} />)}
              </div>
              <blockquote className="mt-1 text-sm leading-snug sm:text-base" data-id="element-155" data-mp="v72hrm77d4la">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-xs leading-tight sm:text-sm" data-id="element-156" data-mp="q8irxaphn8nn">
                <span className="font-extrabold text-navy" data-id="element-157" data-mp="h4n6gjawodem">{t.name}</span>
                <span className="text-ink/70" data-id="element-158" data-mp="m5swg9d6lmkg">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}